import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export const InvalidTokenSlice = createSlice({
  name: "InvalidToken",
  initialState: { data: false },
  reducers: {
    invalidToken: (state, action: PayloadAction<boolean>) => {
      // console.log(action.payload);

      state.data = action.payload;
    },
  },
});

export const { invalidToken } = InvalidTokenSlice.actions;

export default InvalidTokenSlice.reducer;
